import AxiosInstance from 'src/shared/services/axios/interceptor';
import { FeeLevelEnum, FeePeriodList, FeePeriodRequest } from 'src/modules/associations/models/feePeriod';

const controller = 'FeePeriod';

/** Alla perioder för en nivå, äldst först, plus startdatum för den avgift som gäller nu. */
export const getFeePeriods = (level: FeeLevelEnum, associationId: number) => {
  const endpoint = `${controller}/${level}/${associationId}`;
  return AxiosInstance.get<FeePeriodList>(endpoint);
};

/** Skapar en avgift som börjar gälla ett visst datum. Föregående avgift avslutas dagen innan. */
export const createFeePeriod = (level: FeeLevelEnum, associationId: number, request: FeePeriodRequest) => {
  const endpoint = `${controller}/${level}/${associationId}`;
  return AxiosInstance.post(endpoint, request);
};

/** Ändrar en avgift som ännu inte börjat gälla. */
export const updateFeePeriod = (level: FeeLevelEnum, id: number, request: FeePeriodRequest) => {
  const endpoint = `${controller}/${level}/${id}`;
  return AxiosInstance.put(endpoint, request);
};

/** Tar bort en avgift som ännu inte börjat gälla. Avslutade perioder är historik. */
export const deleteFeePeriod = (level: FeeLevelEnum, id: number) => {
  const endpoint = `${controller}/${level}/${id}`;
  return AxiosInstance.delete(endpoint);
};
